import 'twin.macro';

import {
  ActionBoxDataType,
  IntervieweeCardContainerProps,
  ProfileCardDataType,
} from '@/containers/IntervieweeCardContainer/types';

import ProfileActionBox from './card/ProfileActionBox';
import ProfileCard from './card/ProfileCard';

export interface IntervieweeCardPropsType {
  viewer: IntervieweeCardContainerProps['viewer'];
  profileCardData: ProfileCardDataType;
  actionBoxData: ActionBoxDataType[];
}

const IntervieweeCard: React.FC<IntervieweeCardPropsType> = ({
  profileCardData,
  actionBoxData,
  viewer,
}) => {
  return (
    <div tw="w-full flex flex-col gap-y-5">
      <div tw="flex w-full gap-x-2 rounded-2xl border bg-white p-4">
        <img
          tw="hidden md:(block h-20 w-20 p-2)"
          src="/assets/people-placeholder.png"
          alt="skooldio"
        />
        <ProfileCard {...profileCardData} />
      </div>

      {!viewer && (
        <div
          tw="grid gap-2 w-full gap-x-2 rounded-2xl border bg-white p-4 grid-cols-[1fr] lg:grid-cols-[repeat(2, 1fr)] xl:[grid-template-columns:repeat(var(--cols),1fr)]"
          style={
            {
              '--cols': actionBoxData?.length ?? 3,
            } as React.CSSProperties
          }
        >
          {actionBoxData?.map((data, index) => {
            if (!data?.shouldDisplay) return null;

            return <ProfileActionBox key={index} {...data} />;
          })}
        </div>
      )}
    </div>
  );
};

export default IntervieweeCard;
